export default async function downloadLink (blob, fileName) {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${fileName}`; 
    document.body.appendChild(a);
    a.click();

    a.remove();
    URL.revokeObjectURL(url);
}
